import { incrementalId } from "../uikit.helpers/incrementalId.es.js";
import { openBlock, createElementBlock, normalizeClass, createElementVNode, Fragment, renderList, renderSlot, createCommentVNode, toDisplayString } from "vue";
/* empty css             */
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-tabs",
  props: {
    tabList: {
      type: Array,
      required: true
    },
    orientation: {
      type: String,
      default: () => "horizontal",
      validator: (value) => ["horizontal", "vertical"].includes(value)
    },
    initialActiveTab: {
      type: Number,
      default: 1
    }
  },
  $emits: ["selectedTab"],
  data() {
    return {
      activeTab: 1,
      uniqId: incrementalId()
    };
  },
  computed: {
    flexVertical() {
      return this.orientation === "vertical" ? "flex" : "";
    },
    flexHorizontal() {
      return this.orientation === "horizontal" ? "" : "vertical";
    },
    isActive() {
      return (index) => index + 1 === this.activeTab;
    }
  },
  created() {
    this.activeTab = this.initialActiveTab;
  },
  methods: {
    hasSlot(slots, name) {
      return slots[name];
    },
    setActive(index, tab) {
      this.activeTab = index;
      this.scroolToActive(index);
      this.$emit("selectedTab", index, tab);
    },
    getVisibility(index) {
      return !this.isActive(index) ? "hidden" : "";
    },
    scroolToActive(index) {
      if (this.$refs.items[index]) {
        this.$refs.items[index].scrollIntoView({ behavior: "smooth", block: "center", inline: "end" });
      }
    }
  }
};
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
  key: 0,
  class: "icon"
};
const _hoisted_3 = ["src", "width", "height"];
const _hoisted_4 = ["for"];
const _hoisted_5 = ["id", "name", "value"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["uikit-tabs", $options.flexVertical])
  }, [
    createElementVNode("ul", {
      ref: "scroll",
      class: normalizeClass($options.flexHorizontal)
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList($props.tabList, (tab, index) => {
        return openBlock(), createElementBlock("li", {
          key: index,
          ref_for: true,
          ref: "items",
          class: normalizeClass(["tab", { active: $options.isActive(index) }]),
          onClick: ($event) => $options.setActive(index + 1, tab)
        }, [
          renderSlot(_ctx.$slots, "tab-item", { tab }, () => [
            tab.icon ? (openBlock(), createElementBlock("span", _hoisted_2, [
              createElementVNode("img", {
                src: tab.icon.img,
                width: tab.icon.width,
                height: tab.icon.height,
                loading: "lazy",
                alt: ""
              }, null, 8, _hoisted_3)
            ])) : createCommentVNode("", true),
            tab.title ? (openBlock(), createElementBlock("label", {
              key: 1,
              for: `${$data.uniqId}${index}`,
              class: "title"
            }, toDisplayString(tab.title), 9, _hoisted_4)) : createCommentVNode("", true),
            createElementVNode("input", {
              id: `${$data.uniqId}${index}`,
              type: "hidden",
              name: `${$data.uniqId}${index}`,
              value: index + 1
            }, null, 8, _hoisted_5)
          ], true)
        ], 10, _hoisted_1);
      }), 128))
    ], 2),
    (openBlock(true), createElementBlock(Fragment, null, renderList($props.tabList, ({ name }, index) => {
      return openBlock(), createElementBlock(Fragment, { key: index }, [
        $options.hasSlot(_ctx.$slots, name ?? `tabPanel-${index + 1}`) ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(["content", [$options.flexHorizontal, $options.getVisibility(index)]])
        }, [
          renderSlot(_ctx.$slots, name ?? `tabPanel-${index + 1}`, {}, void 0, true)
        ], 2)) : createCommentVNode("", true)
      ], 64);
    }), 128))
  ], 2);
}
const Tabs = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-3e4d5736"]]);
export {
  Tabs as default
};
//# sourceMappingURL=Tabs.vue.es.js.map
